import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Task } from '@/types';
    import DataTableActions from '@/components/datatable/DataTableActions.vue';
    import EditTask from './EditTask.vue';

    interface Props {
        task: Task;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'TasksTableActions',
  props: {
    task: {}
  },
  setup(__props: any) {

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DataTableActions, { data: _ctx.task }, {
    default: _withCtx(() => [
      _createVNode(EditTask, { task: _ctx.task }, null, 8, ["task"])
    ]),
    _: 1
  }, 8, ["data"]))
}
}

})